<template>
  <div class="content-wrapper">
    <div class="content-header">
      <div class="title">非套码管理</div>
    </div>
    <el-card shadow="hover"
      style="margin: 0 15px">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="非套码生产"
          name="1">
          <div class="el-card__header card-header__wrap">
            <span class="card-header--title">
              <el-button type="primary"
                icon="el-icon-plus"
                @click="produceCode">生产非套码</el-button>
            </span>
            <div class="card-header--form">
              <el-radio-group v-model="queryType"
                style="margin-right: 10px"
                @change='queryProduceSearch'>
                <el-radio-button :label="0">全部</el-radio-button>
                <el-radio-button :label="1">可分配</el-radio-button>
                <!-- <el-radio-button :label="2">已分配</el-radio-button> -->
              </el-radio-group>
              <el-input placeholder="请输入序号"
                v-model="config.tagNo"
                style="width:200px"
                clearable>
                <el-button slot="append"
                  icon="el-icon-search"
                  @click="queryProduceSearch"></el-button>
              </el-input>
            </div>
          </div>
          <el-table border
            default-expand-all
            class="el-table__expanded"
            v-loading="loading"
            :data="list">
            <el-table-column type="expand"
              width="40">
              <template slot-scope="{row}">
                <el-table :show-header="false"
                  :data="row.detailsList"
                  v-if="row.detailsList"
                  :row-class-name="tableRowClassName">
                  <el-table-column width="40"></el-table-column>
                  <el-table-column label="序号"
                    width="200">
                    <template slot-scope="{row}">
                      {{row.beginTagNo | tagCount() }} - {{row.endTagNo | tagCount() }}
                    </template>
                  </el-table-column>
                  <el-table-column label="标签类型">
                    <template slot-scope="{row}">
                      {{row.tagType | tagType()}}
                    </template>
                  </el-table-column>
                  <el-table-column label="生产时间">
                    <template slot-scope="{row}">
                      {{row.createdTime | dateformat('YYYY-MM-DD') }}
                    </template>
                  </el-table-column>
                  <el-table-column label="标签总数"
                    prop="tagCount"></el-table-column>
                  <el-table-column label="标签剩余数量"
                    prop="notAssignTagCount">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="{row}">
                      <el-button type="text"
                        icon="el-icon-download"
                        @click="downloadtagsegment(row, 'detail')">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="序号"
              width="200">
              <template slot-scope="{row}">
                {{row.beginTagNo | tagCount() }} - {{row.endTagNo | tagCount() }}
                <el-tag v-if="row.isPreassign === 1"
                  size="mini">{{row.refVendorName}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="标签类型">
              <template slot-scope="{row}">
                {{row.tagType | tagType()}}
              </template>
            </el-table-column>
            <el-table-column label="生产时间">
              <template slot-scope="{row}">
                {{row.createdTime | dateformat('YYYY-MM-DD') }}
              </template>
            </el-table-column>
            <el-table-column label="标签总数"
              prop="tagCount"></el-table-column>
            <el-table-column label="标签剩余数量"
              prop="notAssignTagCount">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{row, $index}">
                <el-button type="text"
                  icon="el-icon-share"
                  v-if="row.notAssignTagCount !== 0"
                  @click="distributeCode(row, $index)">分配</el-button>
                <el-button type="text"
                  icon="el-icon-download"
                  v-if="!row.detailsList"
                  @click="downloadtagsegment(row,'list')">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background
            @current-change="handleProduceChange"
            :current-page.sync="config.pageNum"
            :page-size="config.pageSize"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="已分配标签"
          name="2">
          <distribute-table ref="distribute" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <produce-modal ref="produceModal"
      :fetch="gettagsegments"
      :fetchAll="fetchAllList" />
    <distribution-modal ref="distributionModal"
      :tagInfo="tagInfo"
      :fetch="fetchAllList" />
  </div>
</template>

<script>
import ProduceModal from './busi/produce-modal.vue'
import DistributionModal from './busi/distribution-modal.vue'
import DistributeTable from './busi/distribute-table.vue'
const QueryMap = {
  0: {},
  1: {
    isPreassign: 0,
    minNotAssignTagCount: 1
  },
  2: {
    minNotAssignTagCount: 0,
    maxNotAssignTagCount: 0
  }
}
export default {
  name: 'label-code',
  components: { ProduceModal, DistributionModal, DistributeTable },
  data () {
    return {
      loading: false,
      activeTab: '1',
      queryType: 1,
      config: {
        pageNum: 1,
        pageSize: 10,
        tagNo: ''
      },
      list: [],
      total: 0,
      tagInfo: {}
    }
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      return 'success-row'
    },
    gettagsegments () {
      this.loading = true
      this.$store.dispatch('label/gettagsegments', {
        payload: {
          ...this.config,
          ...QueryMap[this.queryType]
        },
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    downloadtagsegment (row, type) {
      this.loading = true
      let postData = type === 'list' ? {
        tagSegId: row.tagSegId
      } : {
        tagSegId: row.tagSegId,
        tagSegDetailsId: row.tagSegDetailsId
      }
      this.$store.dispatch('label/downloadtagsegment', {
        payload: postData,
        success: (res) => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleProduceChange (current) {
      this.config.pageNum = current
      this.gettagsegments()
    },
    queryProduceSearch () {
      this.handleProduceChange(1)
    },
    fetchAllList () {
      this.gettagsegments()
      this.$refs.distribute.gettagassigns()
    },
    produceCode () {
      this.$refs.produceModal.toggleModal(true)
    },
    distributeCode (row, $index) {
      this.tagInfo = {
        tagType: row.tagType,
        beginTagNo: row.nextAssignTagNo,
        notAssignTagCount: row.notAssignTagCount,
        tagSegId: row.tagSegId
      }
      this.$refs.distributionModal.toggleModal(true)
    }
  },
  mounted () {
    this.gettagsegments()
  }
}
</script>
<style lang="stylus">
.el-table__expanded {
  .el-table__expanded-cell {
    padding: 0 !important;
    border: none;
  }

  .el-table__expanded-cell td {
    border-right: none;
  }
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
